import { useMemo } from "react";

import { SmartyAddressKey } from "config";

import { ClientBuilder, SharedCredentials } from "smartystreets-javascript-sdk";
import * as sdkUtils from "smartystreets-javascript-sdk-utils";

type USStreetClient = ReturnType<InstanceType<typeof ClientBuilder>["buildUsStreetApiClient"]>;

type AutoCompleteClient = ReturnType<
  InstanceType<typeof ClientBuilder>["buildUsAutocompleteProClient"]
>;

/**
 * A custom hook to initialize SmartyCore clients.
 * @returns An object containing autoCompleteClient and usStreetClient.
 */
export const useSmartyCore = () => {
  const websiteKey = SmartyAddressKey;

  const autoCompleteClient = useMemo((): AutoCompleteClient => {
    const credentials = new SharedCredentials(websiteKey);
    return new ClientBuilder(credentials)
      .withLicenses(["us-autocomplete-pro-cloud"])
      .buildUsAutocompleteProClient();
  }, [websiteKey]);

  const usStreetClient = useMemo((): USStreetClient => {
    const credentials = new SharedCredentials(websiteKey);
    return new ClientBuilder(credentials).buildUsStreetApiClient();
  }, [websiteKey]);

  return {
    utils: sdkUtils,
    autocomplete: { client: autoCompleteClient },
    street: { client: usStreetClient },
  };
};
